import { useSelector } from "react-redux";
import GraphSkeletonForTrendsMob from "../../../helpers/components/GraphSkeletonForTrendsMob";
import { Box } from "@mui/system";
import ProfitOverTimeChartWrap from "./ProfitContent/ProfitOverTime/ProfitOverTimeChartWrap";
import SpentChartWrap from "./ProfitContent/Spent/SpentChartWrap";
import TotalIncomeChartWrap from "./ProfitContent/TotalIncome/TotalIncomeChartWrap";

const Profit = () => {
  const { loadingTrendsMobData } = useSelector((state: any) => state.trends);
  return (
    <>
      <Box sx={{ px: 2 }}>
        {loadingTrendsMobData ? (
          Array.from({ length: 2 }).map((_, index) => (
            <GraphSkeletonForTrendsMob key={index} />
          ))
        ) : (
          <>
            <ProfitOverTimeChartWrap />
            <SpentChartWrap />
            <TotalIncomeChartWrap />
          </>
        )}
      </Box>
    </>
  );
};

export default Profit;
